import { useNavigate } from 'react-router-dom'
import {
  Avatar,
  Box,
  Container,
  CssBaseline,
  Grid,
  Typography,
} from '@mui/material'
import Skeleton from '@mui/material/Skeleton'
import { useQuery } from '@tanstack/react-query'
import { useAuth } from '../../../hooks'
import modules from '../../../services/modules'
import {
  AppLessonSkeleton,
  BottomMenuNavigation,
  EmptyPage,
  ErrorPage,
  Header,
  HomePageModule,
  SourceLevelBar,
} from '../../../components'

export default function Home() {
  const navigate = useNavigate()
  const { user } = useAuth()

  const {
    data: queryModules,
    isLoading,
    isError,
  } = useQuery({
    queryFn: () => modules.getAll(),
    queryKey: ['modules'],
  })

  return (
    <Container component="main">
      <CssBaseline />
      <Header disableBackButton>
        <Box width={'100%'}>
          <Typography
            variant="h4"
            sx={{ fontSize: 22, fontWeight: 'bold', pb: 1 }}
          >
            {!isLoading ? (
              !isError && <>Level {user?.level}</>
            ) : (
              <Skeleton
                variant="text"
                sx={{ fontSize: '1rem', width: '35%' }}
              />
            )}
          </Typography>
          {!isLoading ? (
            !isError && <SourceLevelBar value={0} sx={{ width: '80%' }} />
          ) : (
            <Skeleton variant="rounded" width={'80%'} height={11} />
          )}
        </Box>

        <Avatar
          onClick={() => {
            navigate('profile')
          }}
          sx={{ height: 45, width: 45 }}
        />
      </Header>
      {!isError ? (
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            spacing={{ xs: 1, md: 1 }}
            columns={{ xs: 4, sm: 18, md: 20 }}
          >
            {!isLoading ? (
              queryModules && queryModules.length > 0 ? (
                queryModules?.map((data) => (
                  <HomePageModule
                    key={data.id}
                    isActive={!data.isLocked}
                    value={data.watchPercent}
                    data={data}
                  />
                ))
              ) : (
                <EmptyPage text={`Desculpa, nenhum módulo foi encontrado!`} />
              )
            ) : (
              <AppLessonSkeleton isListMode={false} />
            )}
          </Grid>
        </Box>
      ) : (
        <ErrorPage
          text={`Encontramos um erro ao buscar os modulos! Por favor, recarregue a página.`}
        />
      )}
      <BottomMenuNavigation />
    </Container>
  )
}
